import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service'
import { } from 'googlemaps';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
    selector: 'app-maptracking',
    template: require('./maptracking.component.html'),
    styles: ['#map {height: 650px;margin: 0px;padding: 0px}']
})
export class MapTrackingComponent implements OnInit {


    static parameters = [ApiService, ActivatedRoute]
    constructor(
        private apiservice: ApiService,
        private activatedRoute: ActivatedRoute
    ) { }

    id: string;
    date: string;
    route: google.maps.Polyline;
    marker: any;
    bounds: any;
    TourRoute: any;
    lat_lng = new Array();
    way_point_length = 0;
    count = 0;
    polylines: any;
    call_array = [];
    coords: marker[] = [];

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.id = params['id'];
            this.date = params['date'];
        });
        this.getLiveLatLng();
    }

    getLiveLatLng() {
        let data = {
            id: this.id,
            date: this.date
        }
        this.apiservice.getlivelatlong(data).subscribe((res: any) => {
            console.log('get live lat long response', res);
            this.coords = res.data;
            this.initMap();
        });
    }

    initMap() {
        this.initialize();
    }

    map;
    moveMarker(map, marker, latlng, lastPosn) {
        // if(lastPosn!=null){
        //     icon4.rotation = google.maps.geometry.spherical.computeHeading(lastPosn, latlng);
        //     marker.setIcon(icon4);
        // }
        marker.setPosition(latlng);
        map.panTo(latlng);
    }

    initialize() {
        this.markerArray = {};
        console.log('coords', this.coords);
        var markLAT = this.coords[0].lat;
        var markLNG = this.coords[0].lng;
        this.map = new google.maps.Map(document.getElementById("map"), {
            center: new google.maps.LatLng(markLAT, markLNG),
            zoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        this.autoRefresh();
    }

    icon = {
        url: '/assets/images/location1.svg', // url
        scaledSize: new google.maps.Size(50, 50), // scaled size
    };

    activeWindow: any;
    markerArray: any;
    Index: any;
    addMarker(map: google.maps.Map, coords) {
        const latLng = { lat: coords.lat, lng: coords.lng };
        var marker;
        if (coords.customer_Id) {
            const contentString =
                `
                <div id="content" class="address_popover">
                <h2> ${coords.Type} </h2>
                <h3>${coords.ChemistName} </h3>
            ` + ((coords.address) ? `<h4>${coords.address}</h4>` : ``) + `
                <div><button class="btn btn-primary">Start Time: ${coords.StartTime} </button> <button class="btn btn-primary">End Time: ${coords.EndTime}</button></div>
                <h5>POB Value: &#8377 ${coords.POB}</h5>
                </div>
            `;
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });
            marker = new google.maps.Marker({
                position: latLng,
                map: map,
                label: this.Index.toString()
            });
            this.Index = this.Index + 1;
            this.markerArray[coords.customer_Id] = marker;
            var parent = this;
            google.maps.event.addListener(marker, 'click', function () {
                if (parent.activeWindow != null) {
                    parent.activeWindow.close();
                }
                infowindow.open(map, marker);
                parent.activeWindow = infowindow;
            });
        } else {

            marker = new google.maps.Marker({
                map: this.map,
                position: latLng,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#f7777e',
                    fillOpacity: 1,
                    strokeColor: '#f7777e',
                    strokeOpacity: 0.9,
                    strokeWeight: 1,
                    scale: 3
                }
            });
        }
        var myLatlng = new google.maps.LatLng(coords.lat, coords.lng);
        this.lat_lng.push(myLatlng);
        this.bounds.extend(marker.getPosition());
    }

    autoRefresh() {
        this.bounds = new google.maps.LatLngBounds();
        var parent = this;
        this.route = new google.maps.Polyline({
            path: [],
            geodesic: true,
            strokeColor: '#79a3f2',
            strokeOpacity: 4.0,
            strokeWeight: 2,
            editable: false,
            map: this.map
        });

        this.marker = new google.maps.Marker({
            map: this.map,
            icon: this.icon,
            animation: google.maps.Animation.DROP,
        });

        if (this.coords.length == 0) {
            return false;
        }
        var coords = this.coords[0];
        this.map.setCenter(coords);
        var latlang = new google.maps.LatLng(coords.lat, coords.lng);
        this.route.getPath().push(latlang);
        this.moveMarker(this.map, this.marker, latlang, null);
        this.Index = 1;
        this.coords.forEach(item => {
            parent.addMarker(parent.map, item);
        });
        this.polylines = [];
        this.TourRoute = [];
        for (var i = 0; i < this.coords.length - 1; i = i + 20) {
            this.count++;
            this.generatePath(i);
        }
    }

    SetCordsDetails(i, coord, Parent) {
        var pause_time = 35;
        if (i >= Parent.TourRoute.length) {
            $('.gm-style-iw>button').click();
            setTimeout(function () {
                Parent.map.setCenter(Parent.bounds.getCenter());
                Parent.map.fitBounds(Parent.bounds);
            }, 35 * 100);
            return false;
        }
        Parent.bounds.extend(coord);
        var SubmitCall = {};
        if (i >= 0) {
            SubmitCall = Parent.coords[Parent.call_array[i]];
        }
        if (SubmitCall && SubmitCall["customer_Id"]) {
            pause_time = 50 * 35;
        }
        $('.gm-style-iw>button').click();
        if (SubmitCall && SubmitCall["customer_Id"]) {
            google.maps.event.trigger(Parent.markerArray[SubmitCall["customer_Id"]], 'click');
        }
        Parent.route.getPath().push(coord);
        if (i == 0) {
            Parent.moveMarker(Parent.map, Parent.marker, coord, null);
        } else {
            Parent.moveMarker(Parent.map, Parent.marker, coord, Parent.TourRoute[i - 1]);
        }
        i = i + 1;
        setTimeout(() => {
            Parent.SetCordsDetails(i, Parent.TourRoute[i], Parent);
        }, pause_time);
    }

    indexOfRequest(result) {
        for (var i = 0; i < this.lat_lng.length - 1; i = i + 1) {
            if (result.request.origin.location == this.lat_lng[i]) {
                return i / 20;
            }
        }
    }

    generatePath(i) {
        var colorVariable = ["#43cd80", "#ff8c69", "blue", "#f08080", "#9b30ff"];
        var service = new google.maps.DirectionsService();
        // var path = new google.maps.MVCArray(this.lat_lng);
        var x = (i % colorVariable.length);
        var color = colorVariable[x];
        // var poly = new google.maps.Polyline({ map: this.map, strokeColor: color, strokeWeight: 0 });
        this.polylines.push({});
        var k = i + 19;
        if (k >= this.lat_lng.length) {
            k = this.lat_lng.length - 1;
        }
        var src = this.lat_lng[i];
        var des = this.lat_lng[k];
        var waypts = [];
        for (var j = i + 1; j < k; j++) {
            waypts.push({ location: this.lat_lng[j], stopover: true });
        }
        // path.push(src);
        // poly.setPath(path);
        var parent = this;
        service.route({
            origin: src,
            destination: des,
            waypoints: waypts,
            optimizeWaypoints: false,
            travelMode: google.maps.TravelMode.DRIVING
        }, function (result, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                var routeIndex = parent.indexOfRequest(result);
                parent.polylines[routeIndex] = result;
            }
            parent.way_point_length++;
            if (parent.count == parent.way_point_length) {
                parent.renderDirectionsPolylines(parent.polylines, parent);
            }
            // else if (status == google.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
            //} 
            else {
                //   alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }

    renderDirectionsPolylines(response, parent) {
        // parent.call_array.push(0);
        var distance = 0;
        for (var x = 0; x < response.length; x++) {
            if (response[x].routes) {
                var legs = response[x].routes[0].legs;
                for (var i = 0; i < legs.length; i++) {
                    var steps = legs[i].steps;
                    distance = distance + (legs[i].distance.value / 1000);
                    var waypoint_order = 0;
                    var waypoint_order_next = 0;
                    if (i == 0) {
                        waypoint_order = i;
                        waypoint_order_next = response[x].routes[0].waypoint_order[i] + 1;
                    } else if (i == legs.length - 1) {
                        waypoint_order = response[x].routes[0].waypoint_order[i - 1] + 1;
                        waypoint_order_next = i + 1;
                    } else {
                        waypoint_order = response[x].routes[0].waypoint_order[i - 1] + 1;
                        waypoint_order_next = response[x].routes[0].waypoint_order[i] + 1;
                    }

                    try {
                        if (x * 20 + waypoint_order == 0) {
                            parent.TourRoute.push(parent.lat_lng[x * 20 + waypoint_order]);
                            parent.call_array.push(x * 20 + waypoint_order);
                        }
                    }
                    catch (ex) {
                        console.log(ex);
                    }

                    for (var j = 0; j < steps.length; j++) {
                        var nextSegment = steps[j].path;
                        for (var k = 0; k < nextSegment.length; k++) {
                            parent.TourRoute.push(nextSegment[k]);
                            parent.call_array.push(0);
                        }
                    }

                    if (isNaN(waypoint_order_next)) {
                        waypoint_order_next = i + 1;
                    }
                    if (parent.lat_lng.length > x * 20 + waypoint_order) {
                        parent.TourRoute.push(parent.lat_lng[x * 20 + waypoint_order_next]);
                        parent.call_array.push(x * 20 + waypoint_order_next);
                    }
                }
            }
        }
        parent.SetCordsDetails(0, parent.TourRoute[0], parent);
    }
}

interface marker {
    lat: number;
    lng: number;
}